<template>
  <div id="Park">
    <div id="park_top">

      <h2>{{info.title}}</h2>
      <div class="use">
        <ul>
          <li @click="out">{{info.out}}</li>
        </ul>
      </div>
    </div>
    <div id="park_content">
      <div id="parkmap"></div>
      <div id="parkright">
        <div class="list">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{info.boxcard}}</span>
            </div>
            <div class="box-cardlist">
              <el-tooltip v-for="(i,j) in  parkMesa" placement="top" :key="j">
                <div slot="content">
                  <ul class="box-ifm">
                    <li>{{i.device}}: {{i.imei}}</li>
                    <li>{{info.lat}}: {{i.lat}}</li>
                    <li>{{info.lng}}: {{i.lng}}</li>
                    <li>{{info.battry}}: {{i.parkStatus.battery}}</li>
                    <li>{{info.parking}}: {{i.parkName}}</li>
                    <li>{{info.time}}: {{setStatus(i.parkStatus.parkStatus)}}</li>
                    <li>{{info.parkDom}}: {{formatTime(i.parkStatus.time)}}</li>
                    <li></li>
                  </ul>
                </div>
                <el-button size="mini" round :type="changetype(i.err)" style="margin:5px;width:100px"  @click="checkedMarker(j)">{{i.parkName}}
                </el-button>
              </el-tooltip>
            </div>
          </el-card>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{info.parkDom}}</span>
            </div>
            <el-button style='line-height: 6px;width: auto' type="success" :class="state==j?'select':''"
                       v-for="(i,j) in  allPark" :key="j" @click="clickn(j)">
              {{i.parklotName}}
            </el-button>
          </el-card>

        </div>
      </div>
      <div id="park_footer">
        <div id="now">

        </div>
        <div id="history">

        </div>
        <div id="listtable">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  let GPS = {
    PI : 3.14159265358979324,
    x_pi : 3.14159265358979324 * 3000.0 / 180.0,
    delta : function (lat, lon) {
      // Krasovsky 1940
      //
      // a = 6378245.0, 1/f = 298.3
      // b = a * (1 - f)
      // ee = (a^2 - b^2) / a^2;
      let a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
      let ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
      let dLat = this.transformLat(lon - 105.0, lat - 35.0);
      let dLon = this.transformLon(lon - 105.0, lat - 35.0);
      let radLat = lat / 180.0 * this.PI;
      let magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      let sqrtMagic = Math.sqrt(magic);
      dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
      dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
      return {'lat': dLat, 'lon': dLon};
    },

    //GPS---高德
    gcj_encrypt : function ( wgsLat , wgsLon ) {
      if (this.outOfChina(wgsLat, wgsLon))
        return {'lat': wgsLat, 'lon': wgsLon};

      let d = this.delta(wgsLat, wgsLon);
      return {'lat' : wgsLat + d.lat,'lon' : wgsLon + d.lon};
    },
    outOfChina : function (lat, lon) {
      if (lon < 72.004 || lon > 137.8347)
        return true;
      if (lat < 0.8293 || lat > 55.8271)
        return true;
      return false;
    },
    transformLat : function (x, y) {
      let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
      ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
      ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
      return ret;
    },
    transformLon : function (x, y) {
      let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
      ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
      ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
      ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
      return ret;
    }
  };
  import Echarts from 'echarts'
  import parkBlue from '../../../static/parkblue.png'
  import parkcGreen from '../../../static/parkcgreen.png'
  import parkcRed from '../../../static/parkcred.png'
  import logo from '../../assets/img/logo.png'
  import parkc from '../../../static/parkc.png'

  export default {
    name: 'parking',
    data() {
      return {
        allPark: [],
        parkMesa: [],
        state: 0,
        data: [],
        allFull: [],
        parkHistory: [],
        markers: [],
        marker: null,
        map: null,
        parkMarkers: [],
        info:{
          title:'智慧城市管理系统 · 智能停车位',
          out:'退出',
          boxcard:'车位详情',
          lng:'经度',
          lat:'纬度',
          battry:'电量',
          parking:'车位',
          time:'时间',
          parkDom:'停车场',
          normal:'正常',
          lowbettry:'低电量',
          parknow:'停车位实时数据',
          nul:'空位',
          error:'异常位',
          full:'满位',
          parkDatechange:'车位数据变化',
          num:'个数',
          parkAll:'停车场停车次数',
          parkInfo:'停车场信息',
          name:'名称',
          price:'单价',
          aaa:'元/小时',
          parkNuma:'停车位个数',
          more:'详细'
        },
        infoList:{
          en:{
            title:'智慧城市管理系统 · 智能停车位',
            out:'退出',
            boxcard:'车位详情',
            lng:'纬度',
            lat:'经度',
            battry:'电量',
            parking:'车位',
            time:'状态',
            parkDom:'停车场',
            normal:'正常',
            lowbettry:'低电量',
            parknow:'停车位实时数据',
            nul:'空位',
            error:'异常位',
            full:'满位',
            parkDatechange:'车位数据变化',
            num:'个数',
            parkAll:'停车场停车次数',
            parkInfo:'停车场信息',
            name:'名称',
            price:'单价',
            aaa:'元/小时',
            parkNuma:'停车位个数',
            more:'详细',
            no:'无车',
            you:'有车'
          },
          zh:{
            title:'Smart city management system smart parking',
            out:'Out',
            boxcard:'Parking details',
            lng:'Lng',
            lat:'Lat',
            battry:'Battry',
            parking:'carport',
            time:'Status',
            parkDom:'Parking lot',
            normal:'Normal',
            lowbettry:'LowerBattry',
            parknow:'Real time parking data',
            nul:'Empty',
            error:'Warn',
            full:'Full',
            parkDatechange:'Change of parking data',
            num:'Num',
            parkAll:'Number of parking lots',
            parkInfo:'ParkingInfo',
            name:'Name',
            price:'Price',
            aaa:'Yuan / hour',
            no:'normal',
            you:'Occupy',
            parkNuma:'Number of parking Spaces',
            more:'More'
          }
        }
      }
    },
    methods: {
      checkedMarker(i){
      if(this.parkMarkers[i]!=undefined){
        AMap.event.trigger(this.parkMarkers[i], 'click')
      }


      },
      out(){
          this.$router.push({path: "/product"});
      },
      formatTime(time) {
        // let les = new Date();
        // console.log('time'+':'+time);
        // console.log(new Date(time * 1000));
        // let localOffset0=new Date().getTimezoneOffset();//fen值
        // console.log(localOffset0)
        // let localOffset = localOffset0*60;//秒值-差值的秒值
        // let unixtime = time+localOffset;
        // console.log(new Date(unixtime * 1000));
        // let unixtime = time;
        let unixTimestamp = new Date(time * 1000 + 3600000*8);//本地区毫秒值
        // console.log('转换前的0时区'+time);
        // console.log('本地时间为'+unixTimestamp/1000);
    
        // console.log(time * 1000 + 3600000*8);
        // let commonTime = unixTimestamp.toLocaleString();
        // console.log(unixTimestamp)
        let Y = unixTimestamp.getFullYear();
        let M = ((unixTimestamp.getMonth() + 1) >= 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1));
        let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate());
        let H = (unixTimestamp.getHours() >= 10 ? unixTimestamp.getHours() : '0' + unixTimestamp.getHours());
        let N = (unixTimestamp.getMinutes() >= 10 ? unixTimestamp.getMinutes() : '0' + unixTimestamp.getMinutes());
        let S = (unixTimestamp.getSeconds() >= 10 ? unixTimestamp.getSeconds() : '0' + unixTimestamp.getSeconds());
        let toDay = Y + '-' + M + '-' + D + " " + H + ":" + N + ":" + S;
        return toDay
      },
      setStatus(e) {
        if (e == 0) {
          return  this.info.no
        } else if (e == 1) {
          return  this.info.you
        }
      },
      changetype(err) {
        if (err == 0) {
          return 'info'
        } else if (err == 1) {
          return 'success'
        } else if (err == 2) {
          return 'danger'
        }
      },
      clickn(i) {
        AMap.event.trigger(this.markers[i], 'click')

      },
      parkMes(id, lng, lat) {
        this.map.setZoomAndCenter(6, [lng, lat]);
        this.$axios({
          method: 'post',
          url: '/data/service/do100/getParkHistoryByParkLot?userId='+localStorage.getItem("userId")+'&parkLotId=' + id
        }).then(res => {
          this.parkHistory = res.data.data.do1009DaysHistoryList;
          for (let i in   res.data.data.do1009DaysHistoryList) {
            this.parkHistory[i].eventTime = new Date(this.parkHistory[i].eventTime * 1000).getDate() + '号'
          }
        });

        this.$axios({
          method: 'post',
          url: '/data/service/do100/getParkByParkLot?userId='+localStorage.getItem("userId")+'&parkLotId=' + id
        }).then(res => {
          // console.log(res)
          this.data = [res.data.data.abnormalNumber, res.data.data.noOccupyNumber, res.data.data.occupyNumber];

          let yichang = res.data.data.abnormalParkInfoList;
          let nomalfull = res.data.data.nomalParkInfoList;
          for (let i in yichang) {
            yichang[i].err = 0
          }
          for (let i in nomalfull) {
            if (nomalfull[i].parkStatus.parkStatus == 0) {
              nomalfull[i].err = 1
            } else {
              nomalfull[i].err = 2
            }
          }
          this.parkMesa = yichang.concat(nomalfull);
          // console.log(this.parkMesa);
          let compare = function (prop) {
            return function (obj1, obj2) {
              let val1 = obj1[prop];
              let val2 = obj2[prop];
              if (val1 < val2) {
                return -1;
              } else if (val1 > val2) {
                return 1;
              } else {
                return 0;
              }
            }
          };
          this.parkMesa.sort(compare('id'));

          for (let i in this.parkMesa) {
            if (this.parkMesa[i].parkStatus.battery == 0) {
              this.parkMesa[i].parkStatus.battery = this.info.normal
            } else {
              this.parkMesa[i].parkStatus.battery =this.info.lowbettry
            }
            if (this.parkMesa[i].imei.length == 16) {
              this.parkMesa[i].device = 'Deveui'
            } else if (this.parkMesa[i].imei.length == 15) {
              this.parkMesa[i].device = 'imei'
            } else {
              this.parkMesa[i].device = 'Devaddr'
            }
          }
        })

      },
      ehcartOne(myChart,val) {

        let option = {

          grid: {
            left: 20,
            top: '40%',
            bottom: '10%',
            right: 40,
            containLabel: true
          },
          title: {
            text: this.info.parknow,
            left: 'center',
            top: 10,
            textStyle: {
              color: '#666'
            }
          },
          legend: {
            orient: 'vertical',
            x: 'left',
            data: [this.info.nul,this.info.error,this.info.full]
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: [
            {
              name: this.info.parkDatechange,
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: [
                {value: this.data[1], name: this.info.nul},
                {value: this.data[2], name: this.info.error},
                {value: this.data[0], name:this.info.full}

              ],

              label: {},
              labelLine: {
                normal: {
                  smooth: 0.2,
                  length: 10,
                  length2: 20
                }
              },

              animationType: 'scale',
              animationEasing: 'elasticOut',
              animationDelay: function (idx) {
                return Math.random() * 200;
              }
            }
          ],
          color: ['#67C23A', '#F56C6C', '#909399'],
        };
        myChart.setOption(option)
      },
      ehcartTwe(myChart,val) {

        let timeData = [];
        let nomal = [];
        let error = [];
        let full = [];
        for (let i  in  val) {
          timeData.push(val[i].eventTime);
          error.push(val[i].abnormalNumber);
          nomal.push(val[i].noOccupyNumber);
          full.push(val[i].occupyNumber)
        }

        let option1 = {
          title: {
            text: this.info.parkDatechange
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          grid: {
            top:'23%',
            bottom: '20%',
          },
          legend: {
            top:'10%',
            data: [this.info.nul, this.info.full, this.info.lowbettry]
          },
          xAxis: [
            {
              type: 'category',
              data: timeData,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: '{value} '
              }
            },
            {
              type: 'value',
              name: this.info.num,
              axisLabel: {
                formatter: '{value} '
              }
            }
          ],
          series: [
            {
              name: this.info.nul,
              type: 'bar',
              color: '#3a89c2',
              data: nomal
            },
            {
              name: this.info.full,
              type: 'bar',
              color: '#F56C6C',
              data: full
            },
            {
              name: this.info.lowbettry,
              type: 'line',
              yAxisIndex: 1,
              color: '#E6A23C',
              data: error
            }
          ]
        };
        myChart.setOption(option1)
      },
      ehcartThree(myChart,val) {

        let data = [];
        let datastate = [];
        for (let i in val) {
          data.push(val[i].parkLot);
          datastate.push(val[i].occupyNumber)
        }
        let option2 = {

          title: {
            text: this.info.parkAll
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '3%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            type: 'category',
            data: data,
          },
          series: [

            {

              type: 'bar',
              data: datastate
            }
          ]
        };
        myChart.setOption(option2)
      },
      localtionAmap(lng,lat){
        this.$axios({
          method: "get",
          url: `http://restapi.amap.com/v3/assistant/coordinate/convert?locations=${lng},${lat}&coordsys=gps&output=JSON&key=717ee13ba750e7cf65f77b4149b078c5`
        }).then(resp => {

          let locations = resp.data.locations;
          locations = locations.split(",");
          return locations
        })
      }
    },
    mounted() {
      let _this = this;
      let myChart = Echarts.init(document.getElementById('now'));
      let myChart1 = Echarts.init(document.getElementById('history'));
      let myChart2 = Echarts.init(document.getElementById('listtable'));
      let map = new AMap.Map('parkmap', {
        resizeEnable: true,
        zoom: 3,
        expandZoomRange: true,
        center:[sessionStorage.getItem('lng'),sessionStorage.getItem('lat')],
        zooms: [1, 20]
      });
      _this.map = map;
      this.$axios({
        method: "get",
        url: '/data/service/do100/getParkLotByUser?userId='+localStorage.getItem("userId")
      }).then(res => {
        this.allPark = res.data.data;
        this.parkMes(this.allPark[0].parklotId, this.allPark[0].lng, this.allPark[0].lat);
        for (let i in res.data.data) {
          setMarkers(res.data.data[i], i);
        }
      });

      function setPark() {
        _this.parkMarkers = [];
        for (let i in _this.parkMesa) {
          let img;
          if (_this.parkMesa[i].err == 0) {
            img = parkc
          } else if (_this.parkMesa[i].err == 1) {
            img = parkcGreen
          } else {
            img = parkcRed
          }

          let icon = new AMap.Icon({

            imageOffset: [0, 0],
            image: img,
            imageSize: [36, 36]
          });
          let n = Number(i)+1

          let marker = new AMap.Marker({
            position:[GPS.gcj_encrypt(_this.parkMesa[i].lat,_this.parkMesa[i].lng).lon,GPS.gcj_encrypt(_this.parkMesa[i].lat,_this.parkMesa[i].lng).lat],
            zIndex: 111,
            map: map,
            icon: icon,
            topWhenClick:true,
            label: {
              content: "<p class='parkNum'>"+n+"</p>",
              offset: new AMap.Pixel(8, 3)

            },
            shadow: ''
          });
          _this.parkMarkers.push(marker)
          AMap.event.addListener(marker, 'click', function () {
            for(let i in _this.parkMarkers){
              _this.parkMarkers[i].setzIndex(100)
              _this.parkMarkers[i].setAnimation('AMAP_ANIMATION_NONE')
            }
            marker.setAnimation('AMAP_ANIMATION_BOUNCE')
            marker.setzIndex(999)
          });

        }
      }

      function setMarkers(n, i) {
        let data = n;
        let icon = new AMap.Icon({
          imageOffset: [0, 0],
          image: parkBlue,
          imageSize: [36, 36]
        });

        let marker = new AMap.Marker({
          position: [GPS.gcj_encrypt(n.lat,n.lng).lon,GPS.gcj_encrypt(n.lat,n.lng).lat],
          zIndex: 111,
          map: map,
          icon: icon,
          shadow: ''
        });

        _this.markers.push(marker);
        if( _this.markers.length>1){
          map.setFitView();
        }
        AMapUI.loadUI(['overlay/SimpleInfoWindow'], function (SimpleInfoWindow) {
          let infoWindow = new SimpleInfoWindow({
            infoTitle: "<div class='parkifm'><img src='" + logo + "'/>"+_this.info.parkInfo+"</div>",
            infoBody: '<ul class="parkifmcon"><li>'+_this.info.name+'：<%= parklotName %></li><li>'+_this.info.price+'：<%=univalence%>'+_this.info.aaa+'</li><li>'+_this.info.lng+'：<%=lng%></li><li>'+_this.info.lat+'：<%=lat%></li><li>'+_this.info.parkNuma+'：<%= count %></li><li style="color:#f20;text-decoration: underline;text-align: center;cursor: pointer">'+_this.info.more+'</li></ul>',
            infoTplData: {
              parklotName: data.parklotName,
              univalence: data.univalence,
              lng: data.lng,
              count: data.count,
              lat: data.lat
            },
            closeWhenClickMap: true,
            offset: new AMap.Pixel(9, -35)
          });

          infoWindow.get$InfoBody()[0].children[0].children[5].onclick = function () {
            map.setZoomAndCenter(18,[GPS.gcj_encrypt(n.lat,n.lng).lon,GPS.gcj_encrypt(n.lat,n.lng).lat]);
            _this.marker = marker;
            marker.hide();
            setPark();
            infoWindow.close()
          };

          function openInfoWin() {
            infoWindow.open(map, [data.lng, data.lat]);
          }

          AMap.event.addListener(marker, 'click', function () {
            marker.show();
            openInfoWin();
            _this.state = i;
            _this.parkMes(data.parklotId, data.lng, data.lat);
            if (_this.parkMarkers.length != 0) {
              for (let i in _this.parkMarkers) {
                _this.parkMarkers[i].hide()
              }
            }
          });


        })

      }

      AMap.event.addListener(map, 'zoomend', function () {
        if (_this.marker) {
          if (map.getZoom() < 13) {
            _this.marker.show();
            for (let i in _this.parkMarkers) {
              _this.parkMarkers[i].hide()
            }
          } else if (map.getZoom() > 15) {
            _this.marker.hide();
            for (let i in _this.parkMarkers) {
              _this.parkMarkers[i].show()
            }
          }
        }
      });


      this.$axios({
        method: 'post',
        url: '/data/service/do100/getOccupyNumberByParkLot?userId='+localStorage.getItem("userId")
      }).then(res => {
        this.allFull = res.data.data.parkLotUseNumberList
      });
      this.$watch("allFull", function (val) {

        this.ehcartThree(myChart2,val)
      });
      this.$watch("data", function (val) {

        this.ehcartOne(myChart,val)
      });
      this.$watch("parkHistory", function (val) {

        this.ehcartTwe(myChart1,val)
      })

    },
    beforeMount(){
      if (localStorage.getItem("lang") == "en") {
        this.info=this.infoList.zh
      } else {
        this.info=this.infoList.en
      }
    }
  }
</script>
<style>
  * {
    margin: 0;
    padding: 0;
    list-style: none;

  }

  .box-ifm li {
    line-height: 24px;
  }

  #Park {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    overflow: auto;
    background-color: #fff
  }

  #park_top {
    width: 100%;
    height: 8%;
    z-index: 999;
    background-color: #4d76f5;
    position: relative;
  }



  #Park .select {
    box-shadow: 0 0 2px rgba(37, 37, 37, 0.7);
    border: 1px solid #799be2;
  }

  #park_content {
    width: 100%;
    height: 100%;
    background-color: transparent
  }

  @media screen  and (max-width: 1660px) {
    #park_top {
      width: 1660px;
      height: 70px;
    }

    #park_content {
      width: 1660px;
      height: 1000px;
    }
  }
  .parkNum{
    border: none;
    background-color: transparent;
  }
  #parkmap {
    width: 60%;
    height: 60%;
    float: left;
    background-color: #fff
  }

  #park_footer {
    width: 100%;
    height: 40%;
    float: left;
    background-color: #e3ebf2
  }

  .parkifmcon {
    padding: 10px 10px;
    box-sizing: border-box;
  }

  .parkifmcon li {
    line-height: 30px;
    font-size: 15px;
  }

  #parkright {
    width: 40%;
    height: 60%;
    float: left;
  }

  .use {
    width: 20%;
    height: 100%;
    float: right;
    color: #fff;
    position: relative;

  }

  #park_top h2 {
    position: absolute;
    top: 50%;
    left: 15%;
    height: 30px;
    line-height: 30px;
    font-size: 24px;
    color: #fff;
    margin-top: -15px;
  }

  .use ul {
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -15px;

  }

  .use ul li {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    display: inline-block;
  }

  .listheader {
    width: 100%;
    height: 30px;
    background-image: linear-gradient(to top, rgba(61, 136, 236, 0.74), rgba(61, 136, 236, 0.74), rgba(61, 136, 236, 0.74));
  }

  .list {
    width: 100%;
    height: 50%;
  }

  .box-card {
    height: 100%;
    overflow: auto;
  }

  .box-cardlist {
    height: 100%;

  }

  .parkifm {
    width: 240px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    background-color: #4d76f5;
    color: #fff;
    border-radius: 6px 6px 0 0;
  }

  .parkifm:before {
    content: "";
    display: inline-block;
    line-height: 30px;
    margin-right: 10px;
    vertical-align: middle;
  }

  .parkifm img {
    width: 80px;
    line-height: 30px;
    margin-right: 15px;
    vertical-align: center;
  }

  .parkifm span {
    vertical-align: middle;
  }

  #Park .amap-ui-smp-ifwn-info-title {
    background-color: #4d76f5;
    padding: 0;
    box-sizing: border-box;
    border-bottom: none;
    border-radius: 3px;
  }

  #Park .amap-ui-smp-ifwn-content-body {
    padding: 0;
    box-sizing: border-box;
    border: none;
  }

  #Park .amap-ui-smp-ifwn-def-tr-close {
    color: #fff;
  }

  #Park .amap-ui-smp-ifwn-def-tr-close:hover {
    color: #fff;
    text-shadow: 0 0 4px #fff;
    background-color: transparent;
  }

  #Park .amap-ui-smp-ifwn-container {
    border-radius: 6px;
  }

  #now {
    width: 30%;
    height: 100%;
    background-color: #fff;
    float: left;
    box-sizing: border-box;
    border-right: none;
    padding: 3%;
  }

  #history {
    width: 30%;
    background-color: #fff;
    height: 100%;
    float: left;
    box-sizing: border-box;
    border-right: none;
    padding: 3%;
  }

  #listtable {
    width: 40%;
    background-color: #fff;
    height: 100%;
    float: left;
    border-right: none;
    box-sizing: border-box;
    padding: 3%;
  }
  #Park .amap-marker-label{
    background-color: #fff;
    color: #0c111a;
    border: none;
    text-align: center;
    border-radius: 10px;
    width: 14px;
    height: 14px;
  }
  #Park .amap-marker-label p{
    width: 14px;
    height: 14px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/parking/parking.vue